import { render, staticRenderFns } from "./ViewerDesignEmptyHint.vue?vue&type=template&id=ca135d4a"
import script from "./ViewerDesignEmptyHint.vue?vue&type=script&lang=js"
export * from "./ViewerDesignEmptyHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports